import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import {
  IRecognitionLeaderboardEmployee,
  IRecognitionLeaderboardTotals,
} from 'types/income';
import { TableDataResponse } from 'types/general';
import {
  exportXlsxConfig,
  getSorting,
  mergeOrgStructureIds,
} from 'utils/general';
import { RecognitionLeaderboardFilters } from './recognition-leaderboard.types';

const getFilters = (filters: Partial<RecognitionLeaderboardFilters>) => {
  const orgStructure = mergeOrgStructureIds(filters);

  return {
    page: filters.page,
    pageSize: filters.pageSize,
    ...getSorting(filters.sort),
    search: filters.search || undefined,
    filter: {
      type: filters.type,
      employeeId: filters.employees,
      companyId: orgStructure.companies,
      departmentId: orgStructure.departments,
      teamIds: orgStructure.teams,
      dateFrom: filters.date?.from,
      dateTo: filters.date?.to,
      achievementIds: filters.achievements,
    },
  };
};

interface GetLeaderboard {
  filters: Partial<RecognitionLeaderboardFilters>;
}

interface ExportXls {
  filters: Partial<RecognitionLeaderboardFilters>;
}

export const loaders = {
  getLeaderboard: ({ filters }: GetLeaderboard) => {
    return api<
      TableDataResponse<IRecognitionLeaderboardEmployee> &
        IRecognitionLeaderboardTotals
    >({
      url: Endpoints.clientAdmin.recognitions.leaderboard.root,
      params: {
        ...getFilters(filters),
      },
    });
  },
  exportXls: ({ filters }: ExportXls) => {
    const { page, pageSize, sorting, direction, ...restFilters } =
      getFilters(filters);
    return api({
      url: Endpoints.clientAdmin.recognitions.leaderboard.export.xls,
      params: {
        ...restFilters,
      },
      ...exportXlsxConfig,
    });
  },
};
